import { createRouter, createWebHistory } from "vue-router";

import DashboardView from "../views/DashboardView.vue";
import EmployeesListView from "../views/EmployeesListView.vue";
import Step1 from "../views/Step1.vue";
import Step2 from "../views/Step2.vue";
import Step3 from "../views/Step3.vue";
import Step4 from "../views/Step4.vue";
import Step5 from "../views/Step5.vue";
import Step6 from "../views/Step6.vue";
import DashboardVietBaiUser from "@/views/DashboardVietBaiUser.vue";
import DashboardVietBaiAdmin from "@/views/DashboardVietBaiAdmin.vue";
import CtaView from "@/views/CtaView.vue";
import VietBaiHangLoat from "@/views/VietBaiHangLoat.vue";
import QuanLyTaiNguyen from "@/views/QuanLyTaiNguyen.vue";
import LayDuLieuTrangVang from "@/views/LayDuLieuTrangVang.vue";
import DanhSachNganhNghe from "@/views/DanhSachNganhNghe.vue";
import DanhSachCongTy from "@/views/DanhSachCongTy.vue";
import MinhTienAdminHomeView from "@/views/MinhTienAdmin/MinhTienAdminHomeView.vue";
import PhongBanView from "@/views/MinhTienAdmin/PhongBanView.vue";
import NhanVienView from "@/views/MinhTienAdmin/NhanVienView.vue";
import ChamCongView from "@/views/MinhTienAdmin/ChamCongView.vue";
import CheckListTaiXeView from "@/views/MinhTienAdmin/CheckListTaiXeView.vue";
import DonHangView from "@/views/MinhTienAdmin/DonHangView.vue";
import NghiPhepView from "@/views/MinhTienAdmin/NghiPhepView";
import XangDauView from "@/views/MinhTienAdmin/XangDauView.vue";
import GiaoHangBenThuBaView from "@/views/MinhTienAdmin/GiaoHangBenThuBaView.vue";
import FanpageListView from "@/views/FanpageListView.vue";
import BangPhanChiaCongViec from "@/views/BangPhanChiaCongViec.vue";
import KhongGianLamViec from "@/views/KhongGianLamViec.vue";
import BaoGiaNhanhView from "@/views/BaoGiaNhanhView.vue";
import PostFBView from "@/views/PostFBView.vue";
import PhongBan from "@/views/PhongBan.vue";
import ChucVu from "@/views/ChucVu.vue";
import Profile from "@/views/Profile.vue";
import Quyen from "@/views/Quyen.vue";
import ChucNang from "@/views/ChucNang.vue";
import HanhDong from "@/views/HanhDong.vue";
import ApiPermission from "@/views/ApiPermission.vue";
import ArticleList from "@/views/ArticleList.vue";
import ChamCongNhanVien from "@/views/ChamCongNhanVien.vue";

import Login from "../views/Login.vue";
import BlogOnWebsView from "@/views/BlogOnWebsView.vue";
import WebsiteListView from "@/views/WebsiteListView.vue";
import ArticleEditPage from "@/views/ArticleEditPage.vue";
import DanhSachThongBao from "@/views/DanhSachThongBao.vue";
import TaoThongBaoTest from "@/views/TaoThongBaoTest.vue";
import QuanLyThietBi from "@/views/QuanLyThietBi.vue";
import LuuTruCongViec from "@/views/LuuTruCongViec.vue";
import LenhView from "@/views/LenhView.vue";
import QuanLyChamCong from "@/views/QuanLyChamCong.vue";
import DanhSachXe from "@/views/DanhSachXe.vue";
import PhanCongXe from "@/views/PhanCongXe.vue";
import HangMucChecklist from "@/views/HangMucChecklist.vue";
import TaiXe from "@/views/TaiXe.vue";
import QuanLyHangMucBaoDuong from "@/views/QuanLyHangMucBaoDuong.vue";
import TaiXeDoXang from "@/views/TaiXeDoXang.vue";
import TaiXeBaoDuong from "@/views/TaiXeBaoDuong.vue";
import DashboardTongQuanCongViec from "@/views/DashboardTongQuanCongViec.vue";
import DanhSachKhachHangTiemNang from "@/views/DanhSachKhachHangTiemNang.vue";
import RBAC from "@/api/rbac";
import QuanLyLoaiXe from "@/views/QuanLyLoaiXe.vue";
import QuanLyGiayTo from "@/views/QuanLyGiayTo.vue";
import HoSoXeCuaToi from "@/views/HoSoXeCuaToi.vue";
import QuanLyBaoDuong from "@/views/QuanLyBaoDuong.vue";
import TaiXeChecklist from "@/views/TaiXeChecklist.vue";
import QuanLyChecklist from "@/views/QuanLyChecklist.vue";
import QuanLyXangDau from "@/views/QuanLyXangDau.vue";
import QuanLyDonHang from "@/views/QuanLyDonHang.vue";
import Forbidden from "@/views/Forbidden.vue";
import NoiQuyVaHuongDanForm from "@/views/NoiQuyVaHuongDan/NoiQuyVaHuongDanForm.vue";
import NoiQuyVaHuongDanDetail from "@/views/NoiQuyVaHuongDan/NoiQuyVaHuongDanDetail.vue";
import NoiQuyUserView from "@/views/NoiQuyVaHuongDan/NoiQuyUserView.vue";
import KhoDashboard from "@/views/KhoDashboard.vue";
import QuanLyDonHangDieuPhoi from "@/views/QuanLyDonHangDieuPhoi.vue";
import QuanLyDonHangKho from "@/views/QuanLyDonHangKho.vue";
import QuanLyDonHangSales from "@/views/QuanLyDonHangSales.vue";
import QuanLyPhep from "@/views/QuanLyPhep.vue";
import NgayLe from "@/views/NgayLe.vue";
import QuanLyLuong from "@/views/QuanLyLuong.vue";
import QuanLyKhoanLuong from "@/views/QuanLyKhoanLuong.vue";
import NoiQuyVaHuongDanList from "@/views/NoiQuyVaHuongDan/NoiQuyVaHuongDanList.vue";
import HuongDanUserView from "@/views/NoiQuyVaHuongDan/HuongDanUserView.vue";
import QuyDinhUserView from "@/views/NoiQuyVaHuongDan/QuyDinhUserView.vue";
import XeGpsTrangThai from "@/views/XeGpsTrangThai.vue";
import XeMonitorMock from "@/views/XeMonitorMock.vue";
import XeHanhTrinhView from "@/views/XeHanhTrinhView.vue";
import QuanLyChamCongThoiVu from "@/views/QuanLyChamCongThoiVu.vue";
import QuanLyThoiVu from "@/views/QuanLyThoiVu.vue";
import AdminXePhanCong from "@/views/AdminXePhanCong.vue";
import ChiTietCongTrinh from "@/views/CongTrinh/ChiTietCongTrinh.vue";

import CrmZaloMultiModuleHub from "@/views/Slack/CrmZaloMultiModuleHub.vue";
import DiaDiemChamCong from "@/views/DiaDiemChamCong.vue";
import SoTayChiTieuNhanVien from "@/views/ThuChiCongTy/SoTayChiTieuNhanVien.vue";
import ThuChiAdminDashboard from "@/views/ThuChiCongTy/ThuChiAdminDashboard.vue";
import ThuChiAdminList from "@/views/ThuChiCongTy/ThuChiAdminList.vue";
import ThuChiDanhMucAdmin from "@/views/ThuChiCongTy/ThuChiDanhMucAdmin.vue";
import BaoCaoXangDauMobile from "@/views/BaoCao/BaoCaoXangDauMobile.vue";
import TaiXeBaoDuongPage from "@/views/TaiXeBaoDuong/TaiXeBaoDuongPage.vue";
import DemoBaoDuongChat from "@/views/DemoBaoDuongChat.vue";
import AdminGiaoNhanHangHistory from "@/views/AdminGiaoNhanHangHistory.vue";
import NotFound from "@/views/NotFound.vue";
import QuanLyGopYKienNghi from "@/views/GopYKienNghi/QuanLyGopYKienNghi.vue";
import LichSuGopYKienNghi from "@/views/GopYKienNghi/LichSuGopYKienNghi.vue";
import TaoGopYKienNghi from "@/views/GopYKienNghi/TaoGopYKienNghi.vue";
import QuanLyDanhMuc from "@/views/GopYKienNghi/QuanLyDanhMuc.vue";
import AdminChamCongQuick from "@/views/AdminChamCongQuick.vue";
import TamUngLuongAdmin from "@/views/TamUngLuongAdmin.vue";
import PhieuCongMy from "@/views/PhieuCongMy.vue";
import PhieuCongToi from "@/views/PhieuCongToi.vue";
import PhieuCongAdminList from "@/views/PhieuCongAdminList.vue";
import PhieuCongAdminDetail from "@/views/PhieuCongAdminDetail.vue";
import QuanLyCongTrinh from "@/views/CongTrinh/QuanLyCongTrinh.vue";
import AdminPhieuCongLuong from "@/views/AdminPhieuCongLuong.vue";

const routes = [
  //--- 1. MAIN & GENERAL ROUTES (Trang chính & Chung) ---
  {
    path: "/cham-cong-nhan-vien",
    name: "ChamCongNhanVien",
    component: ChamCongNhanVien,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/tat-ca-thong-bao",
    name: "DanhSachThongBao",
    component: DanhSachThongBao,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/tao-thong-bao-test",
    name: "TaoThongBaoTest",
    component: TaoThongBaoTest,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  }, //--- 2. MAIN OPERATIONS (Vận hành chính: Chấm công, Lệnh, Công việc) ---

  {
    path: "/cham-cong-nhan-vien",
    name: "ChamCongNhanVien",
    component: ChamCongNhanVien,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/so-tay-chi-tieu-nhan-vien",
    name: "SoTayChiTieuNhanVien",
    component: SoTayChiTieuNhanVien,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/thu-chi-admin-dashboard",
    name: "ThuChiAdminDashboard",
    component: ThuChiAdminDashboard,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/thu-chi-admin-list",
    name: "ThuChiAdminList",
    component: ThuChiAdminList,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/quan-ly-danh-muc-thu-chi",
    name: "ThuChiDanhMucAdmin",
    component: ThuChiDanhMucAdmin,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/quan-ly-cham-cong",
    name: "QuanLyChamCong",
    component: QuanLyChamCong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["ADMINCHAMCONG_VIEW"],
    },
  },
  {
    path: "/quan-ly-cham-cong-thoi-vu",
    name: "QuanLyChamCongThoiVu",
    component: QuanLyChamCongThoiVu,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["ADMINCHAMCONG_VIEW"],
    },
  },
  {
    path: "/quan-ly-thoi-vu",
    name: "QuanLyThoiVu",
    component: QuanLyThoiVu,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["ADMINCHAMCONG_VIEW"],
    },
  },
  {
    path: "/quan-ly-lenh",
    name: "LenhView",
    component: LenhView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["LENH_VIEW"],
    },
  },
  {
    path: "/quan-ly-phep",
    name: "QuanLyPhep",
    component: QuanLyPhep,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["PHEP_VIEW"],
    },
  },
  {
    path: "/quan-ly-le",
    name: "NgayLe",
    component: NgayLe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["LE_VIEW"],
    },
  },
  {
    path: "/quan-ly-dia-diem-cham-cong",
    name: "DiaDiemChamCong",
    component: DiaDiemChamCong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["LE_VIEW"],
    },
  },
  {
    path: "/quan-ly-khoan-luong",
    name: "QuanLyKhoanLuong",
    component: QuanLyKhoanLuong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["KHOANLUONG_VIEW"],
    },
  },
  {
    path: "/quan-ly-luong",
    name: "QuanLyLuong",
    component: QuanLyLuong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["LUONG_VIEW"],
    },
  },
  {
    path: "/dashboard-tong-quan-cong-viec",
    name: "DashboardTongQuanCongViec",
    component: DashboardTongQuanCongViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      //       permsAny: ["WORKSPACE_VIEW"],
    },
  },
  {
    path: "/",
    name: "KhongGianLamViec",
    component: KhongGianLamViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["WORKSPACE_VIEW"],
    },
  },
  {
    path: "/luu-tru-cong-viec",
    name: "LuuTruCongViec",
    component: LuuTruCongViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/bang-phan-chia-cong-viec/:id",
    name: "BangPhanChiaCongViec",
    component: BangPhanChiaCongViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  }, //--- 3. TRANSPORT MANAGEMENT (Quản lý Vận tải & Tài xế) ---

  {
    path: "/phan-cong-xe", // Lệnh Giao Xe
    name: "PhanCongXe",
    component: PhanCongXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["XEASSIGNMENT_VIEW"],
    },
  },
  {
    path: "/quan-ly-don-hang",
    name: "QuanLyDonHang",
    component: QuanLyDonHang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DONHANG_VIEW"],
    },
  },
  {
    path: "/danh-sach-xe",
    name: "DanhSachXe",
    component: DanhSachXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["XE_VIEW"],
    },
  },
  {
    path: "/quan-ly-loai-xe",
    name: "QuanLyLoaiXe",
    component: QuanLyLoaiXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DMLOAIXE_VIEW"], // <<< ĐÃ SỬA TỪ XE_VIEW
    },
  },
  {
    path: "/quan-ly-giay-to",
    name: "QuanLyGiayTo",
    component: QuanLyGiayTo,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["GIAYTO_VIEW"],
    },
  },
  {
    path: "/hang-muc-checklist",
    name: "HangMucChecklist",
    component: HangMucChecklist,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DMCHECKLIST_VIEW"],
    },
  },
  {
    path: "/hang-muc-bao-duong",
    name: "QuanLyHangMucBaoDuong",
    component: QuanLyHangMucBaoDuong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DMHANGMUCBAODUONG_VIEW"],
    },
  },
  {
    path: "/quan-ly-bao-duong",
    name: "QuanLyBaoDuong",
    component: QuanLyBaoDuong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["BAODUONGXE_VIEW"],
    },
  },
  {
    path: "/quan-ly-checklist",
    name: "QuanLyChecklist",
    component: QuanLyChecklist,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CHECKLIST_VIEW"],
    },
  },
  {
    path: "/quan-ly-xang-dau",
    name: "QuanLyXangDau",
    component: QuanLyXangDau,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["XANGDAU_VIEW"],
    },
  }, // Nhóm con: Tài Xế
  {
    path: "/tai-xe",
    name: "TaiXe",
    component: TaiXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  },
  {
    path: "/tai-xe-do-xang",
    name: "TaiXeDoXang",
    component: TaiXeDoXang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  },
  {
    path: "/ho-so-xe-cua-toi",
    name: "HoSoXeCuaToi",
    component: HoSoXeCuaToi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  },
  {
    path: "/tai-xe-checklist",
    name: "TaiXeChecklist",
    component: TaiXeChecklist,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  }, //--- 4. MARKETING & DATA (Marketing & Dữ liệu) ---

  {
    path: "/danh-sach-khach-hang-tiem-nang",
    name: "DanhSachKhachHangTiemNang",
    component: DanhSachKhachHangTiemNang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["KHACHHANGTIEMNANG_VIEW"],
    },
  },
  {
    path: "/quan-ly-fanpage",
    name: "FanpageListView",
    component: FanpageListView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["FANPAGE_VIEW"],
    },
  },
  {
    path: "/post-fb",
    name: "PostFBView",
    component: PostFBView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["FANPAGE_VIEW"],
    },
  },
  {
    path: "/lay-du-lieu-trang-vang",
    name: "LayDuLieuTrangVang",
    component: LayDuLieuTrangVang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CONGTY_VIEW"],
    },
  },
  {
    path: "/danh-sach-cong-ty",
    name: "DanhSachCongTy",
    component: DanhSachCongTy,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CONGTY_VIEW"],
    },
  },
  {
    path: "/danh-sach-nganh-nghe",
    name: "DanhSachNganhNghe",
    component: DanhSachNganhNghe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["INDUSTRY_VIEW"],
    },
  }, //--- 5. TOOLS (Công cụ) ---

  {
    path: "/bao-gia-nhanh",
    name: "BaoGiaNhanhView",
    component: BaoGiaNhanhView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["ADMIN_VIEW"],
    },
  },
  {
    path: "/quan-ly-tai-nguyen",
    name: "QuanLyTaiNguyen",
    component: QuanLyTaiNguyen,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAINGUYEN_VIEW"],
    },
  }, //--- 6. SYSTEM MANAGEMENT (Quản lý Hệ thống) ---

  {
    path: "/employees-list",
    name: "Employees",
    component: EmployeesListView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NGUOIDUNG_VIEW"],
    },
  },
  {
    path: "/phong-ban",
    name: "PhongBan",
    component: PhongBan,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["PHONGBAN_VIEW"],
    },
  },
  {
    path: "/chuc-vu",
    name: "ChucVu",
    component: ChucVu,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CHUCVU_VIEW"],
    },
  }, // Nhóm con: Phân Quyền
  {
    path: "/quyen",
    name: "Quyen",
    component: Quyen,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["QUYEN_VIEW"],
    },
  },
  {
    path: "/chuc-nang",
    name: "ChucNang",
    component: ChucNang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CHUCNANG_VIEW"],
    },
  },
  {
    path: "/hanh-dong",
    name: "HanhDong",
    component: HanhDong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["HANHDONG_VIEW"],
    },
  },

  {
    path: "/api-permission",
    name: "ApiPermission",
    component: ApiPermission,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["PERMISSION_VIEW"],
    },
  }, // Khác
  {
    path: "/quan-ly-thiet-bi",
    name: "QuanLyThietBi",
    component: QuanLyThietBi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  }, //--- 7. APP-SPECIFIC: VIET BAI (Layout riêng: Ứng dụng Viết bài) ---

  {
    path: "/dashboard-viet-bai-user",
    name: "DashboardVietBaiUser",
    component: DashboardVietBaiUser,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW", "CTA_VIEW", "WPSITE_VIEW"],
    },
  },
  {
    path: "/article-list",
    name: "ArticleList",
    component: ArticleList,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/dashboard-viet-bai-admin",
    name: "DashboardVietBaiAdmin",
    component: DashboardVietBaiAdmin,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/ai-writer",
    name: "Step1",
    component: Step1,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/ai-writer/:id",
    name: "StepEdit",
    component: Step1,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/website-list",
    name: "WebsiteListView",
    component: WebsiteListView,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["WPSITE_VIEW"],
    },
  },
  {
    path: "/cta-list",
    name: "CtaView",
    component: CtaView,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["CTA_VIEW"],
    },
  },
  {
    path: "/viet-bai-hang-loat",
    name: "VietBaiHangLoat",
    component: VietBaiHangLoat,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/blog-on-website-list",
    name: "BlogOnWebView",
    component: BlogOnWebsView,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["WPSITE_VIEW"],
    },
  },
  {
    path: "/edit-article/:id/:wpSiteId",
    name: "edit-article",
    component: ArticleEditPage,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  }, // PHẦN NỘI QUY // -- Phần admin --

  {
    path: "/noi-quy",
    name: "NoiQuyVaHuongDanList",
    component: NoiQuyVaHuongDanList,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_VIEW"],
    },
  },
  {
    path: "/noi-quy/them-moi",
    name: "NoiQuyVaHuongDanCreate",
    component: NoiQuyVaHuongDanForm,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_CREATE"],
    },
  },
  {
    path: "/noi-quy/sua/:id",
    name: "NoiQuyVaHuongDanEdit",
    component: NoiQuyVaHuongDanForm,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_UPDATE"],
    },
  },
  {
    path: "/noi-quy/chi-tiet/:id",
    name: "NoiQuyVaHuongDanDetail",
    component: NoiQuyVaHuongDanDetail,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_VIEW"],
    },
  }, // -- Phần người dùng --

  {
    path: "/noi-quy-cua-toi",
    name: "NoiQuyUserView",
    component: NoiQuyUserView,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/huong-dan-cua-toi",
    name: "HuongDanUserView",
    component: HuongDanUserView,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/quy-dinh-cua-toi",
    name: "QuyDinhUserView",
    component: QuyDinhUserView,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  //--- 1. MAIN & GENERAL ROUTES (Trang chính & Chung) ---
  // {
  //   path: "/",
  //   name: "Dashboard",
  //   component: DashboardView,
  //   meta: {
  //     requiresAuth: true,
  //     SidebarComponent: true,
  //     SidebarAppComponent: false,
  //     HeaderComponent: true,
  //   },
  // },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/tat-ca-thong-bao",
    name: "DanhSachThongBao",
    component: DanhSachThongBao,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/tao-thong-bao-test",
    name: "TaoThongBaoTest",
    component: TaoThongBaoTest,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  }, //--- 2. MAIN OPERATIONS (Vận hành chính: Chấm công, Lệnh, Công việc) ---

  {
    // path: "/cham-cong-nhan-vien",
    path: "/cham-cong-nhan-vien",
    name: "ChamCongNhanVien",
    component: ChamCongNhanVien,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/quan-ly-cham-cong",
    name: "QuanLyChamCong",
    component: QuanLyChamCong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["ADMINCHAMCONG_VIEW"],
    },
  },
  {
    path: "/quan-ly-lenh",
    name: "LenhView",
    component: LenhView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["LENH_VIEW"],
    },
  },
  {
    path: "/quan-ly-phep",
    name: "QuanLyPhep",
    component: QuanLyPhep,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["PHEP_VIEW"],
    },
  },
  {
    path: "/dashboard-tong-quan-cong-viec",
    name: "DashboardTongQuanCongViec",
    component: DashboardTongQuanCongViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/",
    name: "KhongGianLamViec",
    component: KhongGianLamViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/luu-tru-cong-viec",
    name: "LuuTruCongViec",
    component: LuuTruCongViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/bang-phan-chia-cong-viec/:id",
    name: "BangPhanChiaCongViec",
    component: BangPhanChiaCongViec,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  }, //--- 3. TRANSPORT MANAGEMENT (Quản lý Vận tải & Tài xế) ---

  {
    path: "/phan-cong-xe", // Lệnh Giao Xe
    name: "PhanCongXe",
    component: PhanCongXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["XEASSIGNMENT_VIEW"],
    },
  },
  {
    path: "/quan-ly-don-hang",
    name: "QuanLyDonHang",
    component: QuanLyDonHang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DONHANG_VIEW"],
    },
  },
  {
    path: "/danh-sach-xe",
    name: "DanhSachXe",
    component: DanhSachXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["XE_VIEW"],
    },
  },
  {
    path: "/quan-ly-loai-xe",
    name: "QuanLyLoaiXe",
    component: QuanLyLoaiXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DMLOAIXE_VIEW"], // <<< ĐÃ SỬA TỪ XE_VIEW
    },
  },
  {
    path: "/quan-ly-giay-to",
    name: "QuanLyGiayTo",
    component: QuanLyGiayTo,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["GIAYTO_VIEW"],
    },
  },
  {
    path: "/hang-muc-checklist",
    name: "HangMucChecklist",
    component: HangMucChecklist,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DMCHECKLIST_VIEW"],
    },
  },
  {
    path: "/hang-muc-bao-duong",
    name: "QuanLyHangMucBaoDuong",
    component: QuanLyHangMucBaoDuong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DMHANGMUCBAODUONG_VIEW"],
    },
  },
  {
    path: "/quan-ly-bao-duong",
    name: "QuanLyBaoDuong",
    component: QuanLyBaoDuong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["BAODUONGXE_VIEW"],
    },
  },
  {
    path: "/quan-ly-checklist",
    name: "QuanLyChecklist",
    component: QuanLyChecklist,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CHECKLIST_VIEW"],
    },
  },
  {
    path: "/quan-ly-xang-dau",
    name: "QuanLyXangDau",
    component: QuanLyXangDau,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["XANGDAU_VIEW"],
    },
  }, // Nhóm con: Tài Xế
  {
    path: "/tai-xe",
    name: "TaiXe",
    component: TaiXe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  },
  {
    path: "/tai-xe-do-xang",
    name: "TaiXeDoXang",
    component: TaiXeDoXang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  },
  {
    path: "/ho-so-xe-cua-toi",
    name: "HoSoXeCuaToi",
    component: HoSoXeCuaToi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  },
  {
    path: "/tai-xe-checklist",
    name: "TaiXeChecklist",
    component: TaiXeChecklist,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAIXE_VIEW"],
    },
  }, //--- 4. MARKETING & DATA (Marketing & Dữ liệu) ---

  {
    path: "/danh-sach-khach-hang-tiem-nang",
    name: "DanhSachKhachHangTiemNang",
    component: DanhSachKhachHangTiemNang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["KHACHHANGTIEMNANG_VIEW"],
    },
  },
  {
    path: "/quan-ly-fanpage",
    name: "FanpageListView",
    component: FanpageListView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["FANPAGE_VIEW"],
    },
  },
  {
    path: "/post-fb",
    name: "PostFBView",
    component: PostFBView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["FANPAGE_VIEW"],
    },
  },
  {
    path: "/lay-du-lieu-trang-vang",
    name: "LayDuLieuTrangVang",
    component: LayDuLieuTrangVang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CONGTY_VIEW"],
    },
  },
  {
    path: "/danh-sach-cong-ty",
    name: "DanhSachCongTy",
    component: DanhSachCongTy,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CONGTY_VIEW"],
    },
  },
  {
    path: "/danh-sach-nganh-nghe",
    name: "DanhSachNganhNghe",
    component: DanhSachNganhNghe,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["INDUSTRY_VIEW"],
    },
  }, //--- 5. TOOLS (Công cụ) ---
  {
    path: "/slack",
    name: "CrmZaloMultiModuleHub",
    component: CrmZaloMultiModuleHub,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/bao-gia-nhanh",
    name: "BaoGiaNhanhView",
    component: BaoGiaNhanhView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["ADMIN_VIEW"],
    },
  },
  {
    path: "/quan-ly-tai-nguyen",
    name: "QuanLyTaiNguyen",
    component: QuanLyTaiNguyen,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAINGUYEN_VIEW"],
    },
  }, //--- 6. SYSTEM MANAGEMENT (Quản lý Hệ thống) ---

  {
    path: "/employees-list",
    name: "Employees",
    component: EmployeesListView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NGUOIDUNG_VIEW"],
    },
  },
  {
    path: "/phong-ban",
    name: "PhongBan",
    component: PhongBan,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["PHONGBAN_VIEW"],
    },
  },
  {
    path: "/chuc-vu",
    name: "ChucVu",
    component: ChucVu,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CHUCVU_VIEW"],
    },
  }, // Nhóm con: Phân Quyền
  {
    path: "/quyen",
    name: "Quyen",
    component: Quyen,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["QUYEN_VIEW"],
    },
  },
  {
    path: "/chuc-nang",
    name: "ChucNang",
    component: ChucNang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["CHUCNANG_VIEW"],
    },
  },
  {
    path: "/hanh-dong",
    name: "HanhDong",
    component: HanhDong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["HANHDONG_VIEW"],
    },
  },
  {
    path: "/api-permission",
    name: "ApiPermission",
    component: ApiPermission,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["PERMISSION_VIEW"],
    },
  }, // Khác
  {
    path: "/quan-ly-thiet-bi",
    name: "QuanLyThietBi",
    component: QuanLyThietBi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  }, //--- 7. APP-SPECIFIC: VIET BAI (Layout riêng: Ứng dụng Viết bài) ---

  {
    path: "/dashboard-viet-bai-user",
    name: "DashboardVietBaiUser",
    component: DashboardVietBaiUser,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW", "CTA_VIEW", "WPSITE_VIEW"],
    },
  },
  {
    path: "/article-list",
    name: "ArticleList",
    component: ArticleList,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/dashboard-viet-bai-admin",
    name: "DashboardVietBaiAdmin",
    component: DashboardVietBaiAdmin,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/ai-writer",
    name: "Step1",
    component: Step1,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/ai-writer/:id",
    name: "StepEdit",
    component: Step1,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/website-list",
    name: "WebsiteListView",
    component: WebsiteListView,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["WPSITE_VIEW"],
    },
  },
  {
    path: "/cta-list",
    name: "CtaView",
    component: CtaView,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["CTA_VIEW"],
    },
  },
  {
    path: "/viet-bai-hang-loat",
    name: "VietBaiHangLoat",
    component: VietBaiHangLoat,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  },
  {
    path: "/blog-on-website-list",
    name: "BlogOnWebView",
    component: BlogOnWebsView,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["WPSITE_VIEW"],
    },
  },
  {
    path: "/edit-article/:id/:wpSiteId",
    name: "edit-article",
    component: ArticleEditPage,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: false,
      SidebarAppComponent: true,
      HeaderComponent: true,
      permsAny: ["VIETBAI_VIEW"],
    },
  }, // PHẦN NỘI QUY // -- Phần admin --

  {
    path: "/noi-quy",
    name: "NoiQuyVaHuongDanList",
    component: NoiQuyVaHuongDanList,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_VIEW"],
    },
  },
  {
    path: "/noi-quy/them-moi",
    name: "NoiQuyVaHuongDanCreate",
    component: NoiQuyVaHuongDanForm,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_CREATE"],
    },
  },
  {
    path: "/noi-quy/sua/:id",
    name: "NoiQuyVaHuongDanEdit",
    component: NoiQuyVaHuongDanForm,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_UPDATE"],
    },
  },
  {
    path: "/noi-quy/chi-tiet/:id",
    name: "NoiQuyVaHuongDanDetail",
    component: NoiQuyVaHuongDanDetail,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NOIQUY_VIEW"],
    },
  }, // -- Phần người dùng --

  {
    path: "/noi-quy-cua-toi",
    name: "NoiQuyUserView",
    component: NoiQuyUserView,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/nhan-vien-kho",
    name: "KhoDashboard",
    component: KhoDashboard,
    props: true,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["NHANVIENKHO_VIEW"],
    },
  },
  {
    path: "/quan-ly-don-hang-dieu-phoi",
    name: "XeMonitorMock",
    component: XeMonitorMock,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["DIEUPHOI_VIEW"],
    },
  },
  {
    path: "/quan-ly-don-hang-kho",
    name: "QuanLyDonHangKho",
    component: QuanLyDonHangKho,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["QUANLYKHO_VIEW"],
    },
  },
  {
    path: "/quan-ly-don-hang-sales",
    name: "QuanLyDonHangSales",
    component: QuanLyDonHangSales,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["TAODONGIAO_VIEW"],
    },
  },
  {
    path: "/quan-ly-don-hang",
    name: "QuanLyDonHang",
    component: QuanLyDonHang,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
      permsAny: ["ADMIN_VIEW"],
    },
  },
  {
    path: "/trang-thai-xe",
    name: "TrangThaiXe",
    component: XeGpsTrangThai,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  // {
  //   path: "/trang-thai-xe-demo",
  //   name: "TrangThaiXeDemo",
  //   component: XeMonitorMock,
  //   meta: {
  //     requiresAuth: true,
  //     SidebarComponent: true,
  //     SidebarAppComponent: false,
  //     HeaderComponent: true,
  //   },
  // },
  {
    path: "/xe-hanh-trinh",
    name: "XeHanhTrinhView",
    component: XeHanhTrinhView,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/demo",
    name: "DemoBaoDuongChat",
    component: DemoBaoDuongChat,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/admin-phan-cong",
    name: "AdminXePhanCong",
    component: AdminXePhanCong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/quan-ly-cong-trinh",
    name: "QuanLyCongTrinh",
    component: QuanLyCongTrinh,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      HeaderComponent: true,
      title: "Danh Sách Công Trình",
    },
  },
  {
    path: "/tai-bao-duong",
    name: "TaiBaoDuong",
    component: TaiXeBaoDuongPage,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      HeaderComponent: true,
      title: "Danh Sách Công Trình",
    },
  },
  {
    path: "/cong-trinh/:id", // Route động lấy ID công trình
    name: "ChiTietCongTrinh",
    component: ChiTietCongTrinh,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      HeaderComponent: true,
      title: "Chi Tiết Dự Án",
    },
  },
  //--- 8. APP-SPECIFIC: MINH TIEN ADMIN (Layout riêng: Minh Tiến Admin) --- // { //   path: "/minh-tien-admin", //   name: "MinhTienAdminHomeView", //   component: MinhTienAdminHomeView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/phong-ban", //   name: "PhongBanView", //   component: PhongBanView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["NGUOIDUNG_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/nhan-vien", //   name: "NhanVienView", //   component: NhanVienView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/cham-cong", //   name: "ChamCongView", //   component: ChamCongView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/checklist-tai-xe", //   name: "CheckListTaiXeView", //   component: CheckListTaiXeView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/noi-quy", //   name: "NoiQuyVaHuongDanView", //   component: NoiQuyVaHuongDanView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/don-hang", //   name: "DonHangView", //   component: DonHangView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/nghi-phep", //   name: "NghiPhepView", //   component: NghiPhepView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/xang-dau", //   name: "XangDauView", //   component: XangDauView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, // { //   path: "/minh-tien-admin/giao-hang-ben-thu-ba", //   name: "GiaoHangBenThuBaView", //   component: GiaoHangBenThuBaView, //   meta: { //     requiresAuth: true, //     SidebarComponent: false, //     SidebarMTAdmin: true, //     HeaderComponent: true, //     permsAny: ["ADMIN_VIEW"], //   }, // }, //--- 9. AUTH & ERRORS (Xác thực & Lỗi) ---

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      SidebarComponent: false,
      SidebarAppComponent: false,
      HeaderComponent: false,
    },
  },
  {
    path: "/403",
    name: "Forbidden",
    component: Forbidden,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound, // Đảm bảo bạn đã import component này
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/bao-cao-xang-dau",
    name: "BaoCaoXangDauMobile",
    component: BaoCaoXangDauMobile,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/quan-ly-giao-nhan-hang",
    name: "AdminGiaoNhanHangHistory",
    component: AdminGiaoNhanHangHistory,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/cham-cong-nhanh",
    name: "AdminChamCongQuick",
    component: AdminChamCongQuick,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/quan-ly-ung-luong",
    name: "TamUngLuongAdmin",
    component: TamUngLuongAdmin,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/phieu-cong",
    name: "PhieuCongMy",
    component: PhieuCongMy,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/admin-phieu-cong",
    name: "AdminPhieuCongLuong",
    component: AdminPhieuCongLuong,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/phieu-cong-cua-toi",
    name: "PhieuCongToi",
    component: PhieuCongToi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/quan-ly-phieu-cong",
    name: "PhieuCongAdminList ",
    component: PhieuCongAdminList,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/chi-tiet-phieu-cong/:id",
    name: "PhieuCongAdminDetail",
    component: PhieuCongAdminDetail,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },

  {
    path: "/quan-ly-danh-muc-bao-cao",
    name: "QuanLyDanhMucBaoCao",
    component: QuanLyDanhMuc,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/gop-y-kien-nghi/tao-moi",
    name: "TaoGopYKienNghi",
    component: TaoGopYKienNghi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/gop-y-kien-nghi/lich-su",
    name: "LichSuGopYKienNghi",
    component: LichSuGopYKienNghi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
  {
    path: "/gop-y-kien-nghi/quan-ly",
    name: "QuanLyGopYKienNghi",
    component: QuanLyGopYKienNghi,
    meta: {
      requiresAuth: true,
      SidebarComponent: true,
      SidebarAppComponent: false,
      HeaderComponent: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  if (to.meta && to.meta.requiresAuth) {
    RBAC.hydrate();
    if (!RBAC.loaded) {
      try {
        await RBAC.loadMe();
      } catch {}
    }

    if (to.path === "/") {
      if (RBAC.hasAny(["WORKSPACE_VIEW"])) {
        // Nếu có quyền, cho phép vào KhongGianLamViec (đã định nghĩa ở route /)
        return;
      } else {
        // Nếu KHÔNG có quyền, chuyển hướng sang trang chấm công
        return "/cham-cong-nhan-vien";
      }
    }

    const all = to.meta.permsAll || [];
    const any = to.meta.permsAny || [];
    if (all.length && !RBAC.hasAll(all)) return "/403";
    if (any.length && !RBAC.hasAny(any)) return "/403";
  }
  return true;
});

export default router;
